export const INSTALLATION_RESOURCES = 'התקנות‎'
export const PRODUCTION_RESOURCES = 'ייצור'
export const PLANNED_DUE_DATE = 'תאריך ראשוני‎'
export const ENGINEERING_RESOURCES = "הנדסה"
export const TECHNICIANS_RESOURCE = 'שם טכנאי'